import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ClientPickerDialogComponent } from './client-picker-dialog.component';
import { MaterialModule } from '@app/material.module';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { TranslateService, TranslateModule } from '@ngx-translate/core';

@NgModule({
  declarations: [ClientPickerDialogComponent],
  imports: [CommonModule, MaterialModule, FormsModule, ReactiveFormsModule, TranslateModule],
  exports: [ClientPickerDialogComponent],
})
export class ClientPickerDialogModule {}
